import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import moment from "moment";



export const getDataForRepDashboardGridList = createAsyncThunk("Rep-dashboard-grid-list", async (reqBody) => {

    if (!reqBody) {

        reqBody = {
            "condition": {
                "limit": 10,
                "skip": 0
            },
            "sort": {
                "field": "_id",
                "type": "desc"
            },
            "searchcondition": {

            },
            "project": {},
            "token": "",
            "count": false
        }
    }


    console.log("reqbody11==>", reqBody);
    let req_body = {};
    req_body = { ...reqBody };
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "users/rep-dashboard-grid-list", requestOptions);
    const respdata = await response.json();
    // console.log("respdata after endpoint fetch==>", respdata);
    return respdata;


})

export const getDataForRepDashboardChart = createAsyncThunk("Rep-dashboard-chart", async (reqBody) => {

    if (!reqBody) {

        reqBody = {
            "condition": {
                "limit": 10,
                "skip": 0
            },
            "sort": {
                "field": "_id",
                "type": "desc"
            },
            "searchcondition": {

            },
            "project": {},
            "token": "",
            "count": false
        }
    }


    console.log("reqbody11==>", reqBody);
    let req_body = {};
    req_body = { ...reqBody };
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "users/rep-dashboard-chart", requestOptions);
    const respdata = await response.json();
    // console.log("respdata after endpoint fetch==>", respdata);
    return respdata;


})




export const getDataForRepDashboardCard = createAsyncThunk("Rep-dashboard-card", async (reqBody) => {

    if (!reqBody) {

        reqBody = {
            "condition": {
                "limit": 10,
                "skip": 0
            },
            "sort": {
                "field": "_id",
                "type": "desc"
            },
            "searchcondition": {

            },
            "project": {},
            "token": "",
            "count": false
        }
    }


    console.log("reqbody11==>", reqBody);
    let req_body = {};
    req_body = { ...reqBody };
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "users/rep-dashboard-card", requestOptions);
    const respdata = await response.json();
    // console.log("respdata after endpoint fetch==>", respdata);
    return respdata;


})






const RepDashboardReducer = createSlice({
    name: 'RepDashboardReducer',
    initialState: {

        mindate: moment().subtract(7, "days").valueOf(),
        maxDate: moment().valueOf(),

        submitting: false,
        loading: false,
        loaderForRepData: false,
        RepChartData: [],
        RepGridData: [],
        RepCardData: [],
        RepListData: null,

    },
    reducers: {
        clearRepDashboardData(state, action) {
            state.RepChartData = []
            state.RepGridData = []
            state.RepCardData = []
            state.RepListData = null

        },

        setMinMaxTime(state, action) {

            state.mindate = (moment(action.payload[0]).valueOf())
            state.maxDate = (moment(action.payload[1]).valueOf())
            console.log("action11111", state.mindate, state.maxDate);

        }
    },
    extraReducers: {
        [getDataForRepDashboardGridList.rejected]: (state, action) => {
            state.endpointsuccess[action.type] = false
            // state.loading = false;
            state.successAction = false;
            state.loaderForRepData = false;

        },
        [getDataForRepDashboardGridList.pending]: (state, action) => {


            console.log("getDataForRepDashboardGridList=========================>")
            state.loading = true;
            state.loaderForRepData = true;


        },
        [getDataForRepDashboardGridList.fulfilled]: (state, action) => {

            console.log("action from storedata", action)
            if (action.payload.status === 'success') {

                state.loading = false;
                state.RepGridData = action.payload.results.grid_data;
                state.RepListData = action.payload.results.list_data;

                ;
                state.loaderForRepData = false;

            }

        },


        [getDataForRepDashboardCard.rejected]: (state, action) => {
            state.endpointsuccess[action.type] = false
            // state.loading = false;
            state.successAction = false;
            state.loaderForRepData = false;

        },
        [getDataForRepDashboardCard.pending]: (state, action) => {


            console.log("getDataForRepDashboardCard=========================>")
            state.loading = true;
            state.loaderForRepData = true;


        },
        [getDataForRepDashboardCard.fulfilled]: (state, action) => {

            console.log("action from storedata", action)
            if (action.payload.status === 'success') {


                state.loading = false;

                state.RepCardData = action.payload.results.card_data;
                state.loaderForRepData = false;

            }

        },


        [getDataForRepDashboardChart.rejected]: (state, action) => {
            state.endpointsuccess[action.type] = false

            state.successAction = false;
            state.loaderForRepData = false;

        },
        [getDataForRepDashboardChart.pending]: (state, action) => {

            state.loaderForRepData = true;


        },
        [getDataForRepDashboardChart.fulfilled]: (state, action) => {

            console.log("action from storedata", action)
            if (action.payload.status === 'success') {
                state.RepChartData = action.payload.results;
                state.loaderForRepData = false;

            }

        },




    }

})

export default RepDashboardReducer.reducer;
export const { clearRepDashboardData, setMinMaxTime } = RepDashboardReducer.actions;

